import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { BehaviorSubject, defer, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DeviceInfoService {
    constructor() {}

    deviceIdSubject = new BehaviorSubject<string | null>(null);

    public getDeviceId(): Observable<string> {
        if (!!this.deviceIdSubject.getValue()) return this.deviceIdSubject.asObservable().pipe(map((x) => x!));

        return defer(() => Device.getId()).pipe(
            map((deviceId) => {
                this.deviceIdSubject.next(deviceId.identifier);
                return deviceId.identifier;
            })
        );
    }
}
